import { universal } from '../loadable';

export const LoadableUserTimezoneCheck = universal(
  import(/* webpackChunkName: UserTimezoneCheck */ './component'),
  {
    key: 'UserTimezoneCheck',
  }
);
